// Simple Microsoft OAuth for Admin without MSAL (fallback approach)
import { useState } from 'react';

const useSimpleMicrosoftLoginAdmin = ({ onLogin, onClose, setError }) => {
    const [loading, setLoading] = useState(false);

    const handleMicrosoftLogin = () => {
        if (loading) return;
        
        setLoading(true);
        setError('');

        try {
            console.log("🟡 Using simple OAuth flow for admin");
            
            const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
            const redirectUri = `${window.location.origin}/social-callback`;
            const scope = encodeURIComponent("openid email profile");
            const state = encodeURIComponent(JSON.stringify({ 
                timestamp: Date.now(),
                returnUrl: "/admin-dashboard", // Admin redirect to admin dashboard
                isAdmin: true // Flag to indicate this is admin login
            }));

            // Use the standard OAuth URL without MSAL
            const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
                `client_id=${clientId}&` +
                `response_type=code&` +
                `redirect_uri=${encodeURIComponent(redirectUri)}&` +
                `response_mode=query&` +
                `scope=${scope}&` +
                `state=${state}&` +
                `prompt=select_account`;

            console.log("🟡 Generated Admin Auth URL:", authUrl);
            console.log("🟡 Will redirect to /admin-dashboard after login");
            window.location.href = authUrl;
            
        } catch (error) {
            console.error("🔴 Simple Microsoft admin login failed:", error);
            setError(`Microsoft login failed: ${error.message}`);
            setLoading(false);
        }
    };

    return { handleMicrosoftLogin, loading };
};

export default useSimpleMicrosoftLoginAdmin;